import * as _lodash from "lodash";
  export default async function loadItems(prepURL, search, headers, options, method, body) {
        var _this3 = this;

        if (!_this3.shouldLoad || (!_this3.itemsFromUrl && _this3.options.readOnly)) {
          _this3.isScrollLoading = false;
          _this3.loading = false;
          _this3.itemsLoadedResolve();
          return;
        }
      
        const minSearch = parseInt(_this3.component.minSearch, 10);
        if (_this3.component.searchField && minSearch > 0 && (!search || search.length < minSearch)) {
          return _this3.setItems([]);
        }
        
        this.allRecords = this.allRecords || [];
        this.cache = this.cache || {};

        const cacheKey = `${this.component.key}-${search || ""}`;
  
        if (this.cache[cacheKey]?.length > 0) {
          return this.setItems(!search ? this.allRecords : this.cache[cacheKey]);
        }
        
        const take = _this3.component.limit || 10;
        const skip = _this3.isScrollLoading ? _this3.selectOptions.length : 0;
        const filter =_this3.component.filter ? { filter: JSON.parse(_this3.interpolate(_this3.component.filter, {..._this3._data})) } : {};
        const sort =  _this3.component.sort ? { sort: JSON.parse(_this3.component.sort) } : {};
  
        const dataState = {
          take,
          skip,
          ...filter,
          ...sort
        };
  
        // Only add filter if there's a search or we need to map headers
        if (_this3.component.searchField && (search || headers.map && Object.keys(headers.map).length > 0)) {
            dataState.filter = {
                logic: "and",
                filters: []
            };
    
            // Only add search filter if there's a search value
            if (search) {
                dataState.filter.filters.push({
                    field: _this3.component.searchField,
                    operator: "contains",
                    value: search
                });

            if (_this3.component.searchField) {
              dataState.sort = [{ dir: "asc", field: _this3.component.searchField }];
            }
              
            if (headers.map) {
              Object.entries(headers.map).forEach(([item, field]) => {
                const value = _this3.form.data[item];
                if (value) {
                  dataState.filter.filters.push({ field, operator: "contains", value });
                }
              });
            }
            }
          }
      
        
        _this3.loading = true;
        try {
          const response = await makeRequest(method, body, _this3, dataState);
          const recordsByUuid =_this3.component.optionId ? null : await fetchRecordsbyUuid(_this3);
          
          let finalData = recordsByUuid 
            ? [...response, ...recordsByUuid].filter((obj, index, array) => 
                array.findIndex(item => item.uuid === obj.uuid) === index)
            : response;
      
          _this3.allRecords.push(..._lodash.differenceBy(finalData, _this3.allRecords, 'uuid'));
          _this3.cache[cacheKey] = finalData;
          
          await _this3.setItems(finalData, !!search);
      
          if (_this3.component.type === 'selectboxes') {
            _this3.shouldLoad = false;
            _this3.redraw();
          }
        } catch (error) {
          console.error('Error loading items:', error);
          _this3.loading = false;
        }
      }

  async function fetchRecordsbyUuid(_this3) {
    let values = _this3.getValue();
    
    if (!_this3.isRecordsFetchedByUuid && values) {

      const valuesArray = Array.isArray(values) 
      ? values.map(item => item?.uuid || item).filter(Boolean)
      : values?.uuid 
        ? [values.uuid]
        : typeof values === "string" && values 
          ? [values]
          : [];

      if (!valuesArray.length) return null;    

      const filters = valuesArray.map(value => ({
        field: _this3.component.valueProperty || "uuid",
        operator: "contains",
        value: value !== null && typeof value === 'object' ? value[_this3.component.valueProperty || "uuid"] : value
      })); 

      let dataState = {
        skip: 0,
        take:valuesArray.length,
        filter: {
          logic: filters?.length > 1 ? "or" : "and",
          filters: filters,
        }
      };

      try {
        
        const response = await makeRequest( _this3.component?.data.method || "GET", null, _this3, dataState);
        _this3.isRecordsFetchedByUuid = true;
        return response;
      } catch (error) {
        console.error('Error fetching records by UUID:', error);
        return null;
      }

    }
  }

  async function makeRequest(method = "GET", body = null, _this3 = null, dataState = null) {
    try {
      if (!_this3) throw new Error("Context is required");
      
      const component = _this3.component;
      let url = _this3.interpolate(component.data.url, {
        formioBase: _this3.options.wrapperUrl,
        appId: _this3.options.appId,
        ..._this3._data
      });
  
      // Handle data state and filtering
      if (dataState) {
        if (component?.sendfilterParamsInBody) {
          body = { filter: `[${JSON.stringify(dataState)}]` };
        } else if (!url.includes("https") && !url.includes("filter")) {
          url += `${url.includes("?") ? "&" : "?"}filter=[${JSON.stringify(dataState)}]`;
        }
      }
  
      // Make request based on URL type
      if (url.startsWith("https")) {
        const response = await fetch(url);
        if (response.status !== 200) throw response;
        const data = await response.json();
        return component?.selectValues ? data[component.selectValues] : data;
      }
  
      const helper = OSjs.make("oxzion/restClient");
      const response = await helper.request("v1", url, body, method);
  
      if (response.status !== "success") return [];
  
      if (response.data?.optionId) {
        component.optionId = response.data.optionId;
        return Object.values(response.data.options);
      }
  
      return response.data;
    } catch (error) {
      console.error('Request failed:', error);
      throw error;
    }
  }